module.exports = __webpack_public_path__ + "img/img4.c8e2ec7b.png";